import React from 'react'
import { Row, Col, Container } from 'react-bootstrap'
import { StaticQuery, graphql } from 'gatsby'
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import styled from 'styled-components'

class ServicesOne extends React.Component {


    shouldComponentUpdate() {
        return false
    }


    render() {
        const Section = styled.section`
            position: relative;
            overflow: hidden;
            background-color: #000;            
            background-size: cover;
            padding: 100px 0 50px 0;
            .heading {
                width: 100%;
            }
            @media (max-width: 767px) {
                padding: 10px 0 20px 0;           
            }
            @media (min-width:768px) and (max-width:1500px) {
                padding: 50px 0 50px 0;              
            }
          }
        `

        const ServiceContainer = styled.div`
            background-color: rgba(0,0,0,.9);
            padding: 60px 0;
        `


        const ServiceElement = styled.div`
            margin-bottom: 20px;
            text-align: center;
            padding: 40px;
            border-radius: 20px;
            transition: .2s;
            &:hover {
                background-color: #000;
                box-shadow: 0 28px 60px rgb(193, 235, 24, .4);
                transform: translateY(-10px);
            }
        `
        const ServiceHeading = styled.h3`
            font-size: 30px;
            font-weight: 500;
            font-family: Teko;
            color: #fff;
        `
        const ServiceSeparator = styled.div`
            height: 5px;
            width: 50px;
            background-color: #c1eb18;
            margin: auto auto 10px auto;        
         `
        const ServiceIcon = styled.div`
      margin-bottom: 20px;
      img {
        max-height: 70px;
        max-width: 70px;
        width: 100%;
        height: auto;
      }
    `

        const ServiceText = styled.p`
            font-size: 16px;
            font-weight: 300;
            color: #c5c5c5;
            padding-right: 25px;            
        `

        const Text = styled.p`
            font-size: 18px;
            font-weight: 300;
            color: #ffffff;
            padding-bottom: 30px;
            text-align: center;          
        `

        const Color = styled.span`            
            font-weight: bold;
            color: #c1eb18;            
        `

        const Color2 = styled.span`            
            color: #04e5e5;            
        `
        const Heading2 = styled.h2`
            transform: translate(0px, -100px);
            transition: 1s;
            margin-top: 180px;
            font-size: 80px;
            line-height: 100px;
            font-family: Teko;
            font-weight: 500;
            color: #ffffff;
            text-align: center;
            text-transform: uppercase;          
        `
        const ColorV = styled.span`            
            color: #c1eb18;
            font-family: Teko;                        
        `

        return (
            <Section>
                <ServiceContainer>
                    <Container>
                        <Heading2><ColorV>Hosting</ColorV> optimizado para sus <ColorV>aplicaciones</ColorV></Heading2>
                        <Text>
                            Hosting diseñado específicamente para optimizar los
                            sitios web en cuanto a velocidad, rendimiento y seguridad.
                        </Text>

                        <Row>
                            <Col md={4}>

                                <ServiceElement>
                                    <ServiceIcon>
                                        <GatsbyImage image={this.props.image1} alt="PHP 7 y 8" />
                                    </ServiceIcon>
                                    <ServiceHeading>
                                    PHP 7 y 8 – Rendimiento para Colombia
                                    </ServiceHeading>
                                    <ServiceSeparator />
                                    <ServiceText>
                                        Con PHP 7 y 8 tiene menor consumo de RAM, mejor rendimiento, menores caídas y mayor seguridad.
                                    </ServiceText>
                                </ServiceElement>

                            </Col>
                            <Col md={4}>

                                <ServiceElement>
                                    <ServiceIcon>
                                        <GatsbyImage image={this.props.image2} alt="LiteSpeed Web Cache" />
                                    </ServiceIcon>
                                    <ServiceHeading>
                                        LiteSpeed Web Cache
                                    </ServiceHeading>
                                    <ServiceSeparator />
                                    <ServiceText>
                                        Con <Color>LSCache,</Color> puede reducir drásticamente los tiempos de carga y manejar picos de tráfico.
                                    </ServiceText>
                                </ServiceElement>

                            </Col>
                            <Col md={4}>

                                <ServiceElement>
                                    <ServiceIcon>
                                        <GatsbyImage image={this.props.image3} alt="Discos SSD en RAID 10" />
                                    </ServiceIcon>
                                    <ServiceHeading>
                                        Discos SSD en RAID 10
                                    </ServiceHeading>
                                    <ServiceSeparator />
                                    <ServiceText>
                                        Mayor velocidad (unas 15 veces más rápido). Menor cantidad de errores (0.5% vs 2-5%).
                                    </ServiceText>
                                </ServiceElement>

                            </Col>
                            <Col md={4}>

                                <ServiceElement>
                                    <ServiceIcon>
                                        <GatsbyImage image={this.props.image4} alt="Soporte HTTP/2" />
                                    </ServiceIcon>
                                    <ServiceHeading>
                                        Soporte HTTP/2
                                    </ServiceHeading>
                                    <ServiceSeparator />
                                    <ServiceText>
                                        <Color>Soporte HTTP/2 Server Push.</Color> Mayor velocidad (entre un 20-30% más).
                                    </ServiceText>
                                </ServiceElement>

                            </Col>
                            <Col md={4}>

                                <ServiceElement>
                                    <ServiceIcon>
                                        <GatsbyImage image={this.props.image5} alt="1-click-installer" />
                                    </ServiceIcon>
                                    <ServiceHeading>
                                        Fácil 1-click-installer
                                    </ServiceHeading>
                                    <ServiceSeparator />
                                    <ServiceText>
                                        1 click. Ese es todo el proceso de instalación de <Color2>WordPress</Color2> en su plan de hosting.
                                    </ServiceText>
                                </ServiceElement>

                            </Col>
                            <Col md={4}>

                                <ServiceElement>
                                    <ServiceIcon>
                                        <GatsbyImage image={this.props.image6} alt="Sitios web ultrarrápidos" />
                                    </ServiceIcon>
                                    <ServiceHeading>
                                        Sitios web ultrarrápidos
                                    </ServiceHeading>
                                    <ServiceSeparator />
                                    <ServiceText>
                                        <Color>Servidores LiteSpeed Enterprise,</Color> el servidor web más veloz de la industria.
                                    </ServiceText>
                                </ServiceElement>

                            </Col>
                        </Row>
                    </Container>
                </ServiceContainer>
            </Section>
        )
    }

}

const Iconos = (props) => (
    <StaticQuery
        query={graphql`
        {          
          image1: file(relativePath: { eq: "icons/php8.png" }) {
            childImageSharp {
              gatsbyImageData(
              layout: CONSTRAINED
              placeholder: DOMINANT_COLOR
              quality: 80
              formats: [AUTO, WEBP, AVIF]
              width: 70
            )
            }
          }
          image2: file(relativePath: { eq: "icons/litespeed.png" }) {
            childImageSharp {
              gatsbyImageData(
              layout: CONSTRAINED
              placeholder: DOMINANT_COLOR
              quality: 80
              formats: [AUTO, WEBP, AVIF]
              width: 70
            )
            }
          }
          image3: file(relativePath: { eq: "icons/drivessd.png" }) {
            childImageSharp {
              gatsbyImageData(
              layout: CONSTRAINED
              placeholder: DOMINANT_COLOR
              quality: 80
              formats: [AUTO, WEBP, AVIF]
              width: 70
            )
            }
          }
          image4: file(relativePath: { eq: "icons/http2.png" }) {
            childImageSharp {
              gatsbyImageData(
              layout: CONSTRAINED
              placeholder: DOMINANT_COLOR
              quality: 80
              formats: [AUTO, WEBP, AVIF]
              width: 70
            )
            }
          }
          image5: file(relativePath: { eq: "icons/hand.png" }) {
            childImageSharp {
              gatsbyImageData(
              layout: CONSTRAINED
              placeholder: DOMINANT_COLOR
              quality: 80
              formats: [AUTO, WEBP, AVIF]
              width: 70
            )
            }
          }
          image6: file(relativePath: { eq: "icons/speed.png" }) {
            childImageSharp {
              gatsbyImageData(
              layout: CONSTRAINED
              placeholder: DOMINANT_COLOR
              quality: 80
              formats: [AUTO, WEBP, AVIF]
              width: 70
            )
            }
          }         
        }
      `}
        render={(data) => {
            const image1 = getImage(data.image1.childImageSharp.gatsbyImageData);
            const image2 = getImage(data.image2.childImageSharp.gatsbyImageData);
            const image3 = getImage(data.image3.childImageSharp.gatsbyImageData);
            const image4 = getImage(data.image4.childImageSharp.gatsbyImageData);
            const image5 = getImage(data.image5.childImageSharp.gatsbyImageData);
            const image6 = getImage(data.image6.childImageSharp.gatsbyImageData);
            return <ServicesOne data={data} image1={image1} image2={image2} image3={image3} image4={image4} image5={image5} image6={image6}{...props} />;
        }}
    />
);

export default Iconos;
